module.exports = __webpack_public_path__ + "static/transfer_ownership1-fb4c488f9267b117babee1052d463fd6.png";